<template>
  <div class="ability-scroll-flex-3">
    <div
      class="ability-scroll-flex-item"
      @click="moreTap(item)"
      v-for="(item, index) in list"
      :key="index"
    >
      <img :src="item.image_text" />
      <span :style="{marginTop: '2px'}">{{ item.name.length > 12 ? `${item.name.substr(0,10)}...` : item.name }}</span>
      <span style="color: #999; font-size: 0.8rem; margin: 2px 0;transform:scale(0.9)">{{
        item.title
      }}</span>
    </div>
  </div>
</template>

<script>
import { getShowDir } from "@/request/api.js";

export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getShowDir_load();
  },
  methods: {
    async getShowDir_load() {
      const res = await getShowDir({
        albumAlias: this.$store.state.loginInfo.album_alias,
      });
      this.list = res.data;
    },
    moreTap(item) {
      const { album_alias } = this.$store.state.loginInfo;
      this.$router.push({
        path: `/homeCatalog/more?directory_pid=${item.directory_pid}&alias=${album_alias}&title=${item.name}&directory_id=${item.directory_id}`,
      });
    },
  },
};
</script>

<style lang="less" Scope  >
.ability-scroll-flex-3 {
  width: 92%;
  padding: 2% 4%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .ability-scroll-flex-item {
    width: 33.33%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .ability-scroll-flex-item > span:nth-child(3) {
    // font-weight: 900;
    padding-bottom: 0.2rem;
    font-size: 1.6rem;
  }
  .ability-scroll-flex-item > span:nth-child(2) {
    color: #999;
    font-size: 1.2rem;
    margin: 2px 0;
  }
  .ability-scroll-flex-item img {
    width: 4.8rem;
    height: 4.8rem;
  }
  // span{
  //   overflow: hidden;
  //   text-overflow: ellipsis;
  //   display: -webkit-box;
  //   -webkit-line-clamp: 1;
  //   -webkit-box-orient: vertical;
  // }
}
</style>
